export default __webpack_public_path__ + "static/media/error.604bae9f.png";